import { useMsal } from '@azure/msal-react';
import { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { IntlIcon } from '@/components/IntlIcon';
import { getMsalDisplayName } from '@/lib/msal';

export function GlobalTopNav() {
  const { accounts, instance } = useMsal();

  const displayName = useMemo(() => {
    const account = accounts[0];
    return (
      account?.name?.trim() || account?.username?.trim() || getMsalDisplayName()
    );
  }, [accounts]);

  const handleSignOut = () => {
    void instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  return (
    <div className="h-16 bg-[var(--intl-primary-surface)] border-b border-[var(--intl-surface-border)] px-4 flex items-center justify-between gap-3">
      <div className="min-w-0 flex flex-1 items-center">
        <NavLink
          to="/"
          aria-label="International Logo"
          className="flex h-7 w-7 shrink-0 text-white"
        >
          <IntlIcon name="international-logo" className="h-7 w-7" />
        </NavLink>
        <div className="mx-2 h-[17px] w-px shrink-0 bg-separator" aria-hidden />

        <div className="flex min-w-0 items-end gap-2.5">
          <span className="shrink-0 text-[20px] font-medium leading-[20px] text-white">
            My International
          </span>
          <span className="hidden truncate text-base font-normal leading-5 text-white sm:inline">
            Contract administration
          </span>
        </div>
      </div>

      <div className="flex shrink-0 flex-col items-end gap-0.5">
        <span className="hidden text-[13px] font-medium text-white sm:block">
          {displayName || ' '}
        </span>
        <button
          type="button"
          onClick={handleSignOut}
          className="text-[12px] font-medium text-white/70 transition-colors hover:text-white"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
